/**
 * Offer Page (Stub)
 * P20250925-125 — Minimal stub for Make Offer CTA
 */

import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import { fireEvent } from '@/lib/analytics';

export default function OfferStub() {
  const navigate = useNavigate();

  useEffect(() => {
    fireEvent('offer_stub_view', {});
  }, []);

  return (
    <>
      <Helmet>
        <title>Make an Offer - Coming Soon</title>
        <meta name="robots" content="noindex,nofollow" />
      </Helmet>

      <div className="min-h-screen flex items-center justify-center px-4">
        <div className="max-w-md text-center space-y-6">
          <h1 className="text-4xl font-bold">Make an Offer</h1>
          <p className="text-lg text-muted-foreground">
            Our offer system is coming soon. For now, please contact me directly.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button onClick={() => navigate('/support/contact')}>Contact Me</Button>
            <Button variant="outline" onClick={() => navigate('/domains')}>
              Explore Domains
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}
